export enum ActionType {
  OPEN_FORM = 'OPEN_FORM',
  CLOSE_FORM = 'CLOSE_FORM',
  SET_CURRENT_INVOICE = 'SET_CURRENT_INVOICE',
  ADD_INVOICE = 'ADD_INVOICE',
  GET_INVOICES = 'GET_INVOICES',
  UPDATE_INVOICE = 'UPDATE_INVOICE',
  DELETE_INVOICE = 'DELETE_INVOICE',
  SORT_INVOICES = 'SORT_INVOICES',
  SET_FILTER = 'SET_FILTER',
  START_LOADING = 'START_LOADING',
  START_EDITING = 'START_EDITING',
  SHOW_ERROR = 'SHOW_ERROR',
  START_UPDATING = 'START_UPDATING',
  OPEN_MODAL = 'OPEN_MODAL',
  CLOSE_MODAL = 'CLOSE_MODAL',
}
